// Company and site rules from ARCHITECTURE_DECISIONS.md, sections 1 and 2.

/** Company every pre-Firebase label belongs to. Old QR links carry no company code. */
export const LEGACY_COMPANY = "alltech";

/** A QR link with no company code reads as Alltech, permanently. */
export function resolveCompany(code: string | null | undefined): string {
  const trimmed = code?.trim().toLowerCase();
  return trimmed ? trimmed : LEGACY_COMPANY;
}

/**
 * Site number is the first segment of the printed asset ID.
 * "04-ER1-MCC-1A" -> "04". Returns null when the ID does not start with two digits.
 */
export function siteFromAssetId(assetId: string): string | null {
  const match = /^(\d{2})-/.exec(assetId.trim());
  return match?.[1] ?? null;
}
